import * as React from 'react';

export const ExistingFilterContext =
    React.createContext<{ filteredPage: boolean, filter: string }>({ filteredPage: false, filter: null });

export const ExistingFilterProvider = ExistingFilterContext.Provider;
export const ExistingFilterConsumer = ExistingFilterContext.Consumer;
